import { useEffect, useState } from "react";
import { getAllTransactions, deleteTransaction } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";
import { getAllCategories } from "../categories/CategoryService";
import { getAllMerchants } from "../merchants/MerchantService";

export default function TransactionList(){

  const [txns,setTxns] = useState([]);
  const [accounts,setAccounts] = useState([]);
  const [categories,setCategories] = useState([]);
  const [merchants,setMerchants] = useState([]);

  useEffect(()=>{
    load();
  },[]);

  const load = async ()=>{
    setTxns(await getAllTransactions());
    setAccounts(await getAllAccounts());
    setCategories(await getAllCategories());
    setMerchants(await getAllMerchants());
  };

  const nameById = (arr,id,key)=>{
    return arr.find(x=>x.id===id)?.[key] || "-";
  };

  const handleDelete = async (id)=>{
    if(!window.confirm("Delete transaction?")) return;
    await deleteTransaction(id);
    load();
  };

  return (
    <div style={wrap}>
      <h2 style={title}>Transactions</h2>

      <div style={list}>
        {txns.map(t=>(
          <div key={t.id} style={txnCard}>

            <div style={left}>
              <div style={badge(t.transactionType)}>
                {t.transactionType}
              </div>

              <div style={mainInfo}>
                <div style={amount(t.transactionType)}>
                  ₹ {t.transactionAmount}
                </div>

                <div style={meta}>
                  {t.merchantId 
                    ? nameById(merchants,t.merchantId,"merchantName")
                    : "Transfer"
                  } • {t.transactionDate}
                </div>

                <div style={sub}>
                  {t.categoryId 
                    ? nameById(categories,t.categoryId,"categoryName")
                    : "—"
                  } • {
                    t.accountId 
                      ? nameById(accounts,t.accountId,"accountName")
                      : `${nameById(accounts,t.fromAccountId,"accountName")} → ${nameById(accounts,t.toAccountId,"accountName")}`
                  }
                </div>

                {t.description && (
                  <div style={desc}>{t.description}</div>
                )}
              </div>
            </div>

            <div>
              <button onClick={()=>handleDelete(t.id)} style={delBtn}>🗑️</button>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
}

/* ---------- styles ---------- */

const wrap = {
  padding:"30px",
  maxWidth:"1000px",
  margin:"0 auto"
};

const title = {
  fontSize:"26px",
  fontWeight:"700",
  marginBottom:"20px"
};

const list = {
  display:"flex",
  flexDirection:"column",
  gap:"14px"
};

const txnCard = {
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  padding:"16px 18px",
  borderRadius:"14px",
  background:"#fff",
  boxShadow:"0 6px 18px rgba(0,0,0,0.06)",
  border:"1px solid #f0f0f0",
};

const left = {
  display:"flex",
  gap:"14px",
  alignItems:"flex-start"
};

const mainInfo = {
  display:"flex",
  flexDirection:"column",
  gap:"4px"
};

const badge = (type)=>({
  padding:"6px 10px",
  borderRadius:"10px",
  fontSize:"11px",
  fontWeight:"600",
  background:
    type==="EXPENSE" ? "#fee2e2" :
    type==="INCOME" ? "#dcfce7" :
    "#e0f2fe",
  color:
    type==="EXPENSE" ? "#b91c1c" :
    type==="INCOME" ? "#166534" :
    "#075985"
});

const amount = (type)=>({
  fontSize:"18px",
  fontWeight:"700",
  color:
    type==="EXPENSE" ? "#dc2626" :
    type==="INCOME" ? "#16a34a" :
    "#0284c7"
});

const meta = {
  fontSize:"13px",
  color:"#555"
};

const sub = {
  fontSize:"13px",
  color:"#777"
};

const desc = {
  fontSize:"13px",
  color:"#999",
  marginTop:"4px"
};

const delBtn = {
  background:"#fff",
  border:"1px solid #eee",
  borderRadius:"8px",
  padding:"6px 10px",
  cursor:"pointer"
};
